<template>
  <TableGradient
      icon-name="cogs"
      :title="$t('integration.listagem.titulo_pagina')"
      :items="integrations"
      :paginator="paginator"
      :fields="fields"
      :fields-filter="filter"
      :loading="isLoading"
      :initial-fields="initial"
      :text-empty="$t('integration.listagem.table.empty')"
      :text-new="$t('integration.listagem.novo')"
      route-new="vns.integration.create"
      @list="evt => $store.dispatch('integration/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link
          :id="`link-edit-${linha.index}`"
          :to="{ name: 'vns.integration.edit', params: { id: linha.item.id }}"
          class="font-weight-bold">
        {{ $t('integration.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableData from "@/components/TableData";
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "Index",
  components: {TableData, TableGradient},
  computed: {
    ...mapGetters({
      integrations: 'integration/all',
      paginator: 'integration/pagination',
      store_isLoading: 'integration/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('integration.listagem.table.nome'), keyFullName: 'vns_integrations.name', sortable: true},
        {key: 'protocol', label: this.$t('integration.listagem.table.protocolo')},
        {key: 'mnemonic', label: this.$t('integration.listagem.table.mnemonico')},
        {key: 'manufacturer', label: this.$t('integration.listagem.table.fabricante')},
        {key: 'integration_type', label: this.$t('integration.listagem.table.tipo_integracao'), sortable: true},
        {key: 'container_complement', label: this.$t('integration.listagem.table.complemento')},
        {key: 'container_complement_type', label: this.$t('integration.listagem.table.tipo_complemento')},
        {key: 'container_force_complement', label: this.$t('integration.listagem.table.forcar_complemento')},
        {key: 'container_identifier_length', label: this.$t('integration.listagem.table.tamanho_recipiente')},
        {key: 'file_format', label: this.$t('integration.listagem.table.file_format')},
        {key: 'host_homologation', label: this.$t('integration.listagem.table.host_homologacao')},
        {key: 'host_production', label: this.$t('integration.listagem.table.host_producao')},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('integration.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('integration.listagem.table.nome')},
        {key: 'protocol', label: this.$t('integration.listagem.table.protocolo')},
        {key: 'integration_type', label: this.$t('integration.listagem.table.tipo_integracao')},
      ],
      initial: [
        'name',
        'protocol',
        'mnemonico',
        'integration_type',
        'status',
        'id'
      ]
    }
  },
  methods: {
    ...mapActions([
      'integration/listAll'
    ])
  },
  mounted() {
    this['integration/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
